import { SitePage } from '@apps-common/apps/my-monitoring/pages/site/Index'

export const Site = () => <SitePage />
